import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SPINNER_LABELS } from './spinner.labels';

@Component({
  selector: 'app-spinner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent {
  labels = SPINNER_LABELS;

  @Input() isLoading: boolean = false;
  @Input() message: string = this.labels.loading;
}
